export const isTestDomain = () => {
  return ['localhost', 'parcel2go.test.p2g.ninja', 'parcelmonkey.test.p2g.ninja'].includes(window.location.hostname);
};

// Coffee or Test Only Features
export const isTestOrStagingDomain = () => {
  return isTestDomain() || ['parcel2go.main.website.p2g.coffee'].includes(window.location.hostname);
};
